import {useCallback} from 'react';

import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RegenerateAiEmailTemplateFromTemplate as RegenerateAiEmailTemplateFromTemplateMutation,
    RegenerateAiEmailTemplateFromTemplateVariables,
    AiEmailTemplateRegenerateFromTemplateInput,
} from 'nutshell-graphql-types';

import REGENERATE_AI_EMAIL_TEMPLATE_FROM_TEMPLATE from '../mutations/regenerate-ai-email-template-from-template.graphql';
import GET_AI_GENERATED_TEMPLATE_BY_EDITION from '../queries/get-ai-generated-template-by-edition.graphql';

export const useRegenerateAiEmailTemplateFromTemplate = (): {
    regenerateAiEmailTemplateFromTemplate: (
        arg1: AiEmailTemplateRegenerateFromTemplateInput
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [regenerateAiEmailTemplateFromTemplate, {loading, error}] = useMutation<
        RegenerateAiEmailTemplateFromTemplateMutation,
        RegenerateAiEmailTemplateFromTemplateVariables
    >(REGENERATE_AI_EMAIL_TEMPLATE_FROM_TEMPLATE);

    const regenerate = useCallback(
        (input: AiEmailTemplateRegenerateFromTemplateInput) => {
            return regenerateAiEmailTemplateFromTemplate({
                variables: {input},
                update: (_cache, {data}) => {
                    if (!data) return;

                    const aiGeneratedTemplate = data.aiEmailTemplateRegenerateFromTemplate.campaign;

                    for (const edition of aiGeneratedTemplate.editions.edges) {
                        _cache.writeQuery({
                            query: GET_AI_GENERATED_TEMPLATE_BY_EDITION,
                            variables: {editionId: edition.node.id},
                            data: {
                                aiGeneratedTemplateGet: aiGeneratedTemplate,
                            },
                        });
                    }
                },
            });
        },
        [regenerateAiEmailTemplateFromTemplate]
    );

    return {
        regenerateAiEmailTemplateFromTemplate: regenerate,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
